import { IRoleEnum } from "@interfaces";
import { createRoute } from "@routes/utils";

import { financialYearListRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";

const permission = [IRoleEnum.STORE, IRoleEnum.STORE_EMPLOYEE];

const financialYearListRouteMetadata: IRouteMetadataObj<
  typeof financialYearListRoutesObj
> = {
  list: {
    title: "basicInfo.index.title",
    description: "empty",
    lazy: () => import("@pages/basicInfo/financialYearList/page"),
    mode: "index",
    type: "main",
    icon: "Calendar2Line",
    breadcrumbs: [],
    permission,
  },
};

export const financialYearListRoutes = createRoute<
  typeof financialYearListRoutesObj
>(financialYearListRoutesObj, financialYearListRouteMetadata);
